import { render } from "./ListaEsperaNew.vue?vue&type=template&id=6e0c0539&scoped=true"
import script from "./ListaEsperaNew.vue?vue&type=script&lang=js"
export * from "./ListaEsperaNew.vue?vue&type=script&lang=js"

import "./ListaEsperaNew.vue?vue&type=style&index=0&id=6e0c0539&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0c0539"]])

export default __exports__